import { prefetchTimePanelResources } from 'owa-time-panel/lib/utils/prefetchTimePanelResources';
import { onBundleLoadTimeStart } from 'owa-time-panel-datapoints/lib/utils/bundleLoadTimeUtils';

export default function onMyDayButtonClicked(): void {
    // Start the bundle load time tracking
    onBundleLoadTimeStart(Date.now());
    // Prefetch resources for the time panel
    // This is a no-op if the resources are already loaded
    prefetchTimePanelResources();
}
